import classNames from 'classnames';
import React from 'react';

import { Assets, getAssetByName } from '../../assets';

interface Props {
    image: Assets;
    title?: string;
    showTitle?: boolean;
    className?: string;
}

const ProductImage = ({ image, title = '', showTitle = true, className }: Props): JSX.Element => (
    <div className={classNames(className, 'product-image')}>
        {image && <img src={getAssetByName(image)} alt={title} title={title} />}
        {title && showTitle && <h1>{title}</h1>}
    </div>
);

export default ProductImage;
